import request from '@/utils/request'

const baseURL = 'http://43.247.184.50:8101';

export default {
  //获取账户余额
  getAccount(data) {
    return request({
      baseURL,
      url: '/v1/account/get',
      method: 'post',
      data: data
    })
  },

  // 发送交易
  sendSig(data){
    return request({
      baseURL,
      url: '/v1/tx/signed/send',
      method: 'post',
      data: data
    })
  },

  // 查看交易结果
  getTxByHash(data){
    return request({
      baseURL,
      url: '/v1/tx/get',
      method: 'post',
      data: data
    })
  }
}

export function encryptOrdecrypt(methods,data) {
  return request({
      baseURL,
      url: `/v1/key/${methods}`,
      method: 'post',
      data
  })
}
